import { create } from './table-schema';
import useTranslation from '../../hooks/useTranslation';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { convertBigNumToDecimalString } from '../../utils/convert-decimal-to-big-num';
import timeFormAPI from '../../api/ui/timeFormAPI';
import { getTokenTypeName } from '../../constants/base';
import {mailNoToStr} from "../../constants/post";

function useSchemaPartnerDetails() {
  const { t } = useTranslation();
  const locale = useSelector((state) => state.language.locale);

  /**
   * 테이블 헤더에 표시할 항목 문자열 배열
   */
  const headerKeys = [
    'admin.event.newUser.partnerDetails.table.head.accountNo', // "ID",
    'admin.event.newUser.partnerDetails.table.head.marketListingNo', // "마켓 거래 번호",
    'admin.event.newUser.partnerDetails.table.head.postNo', // "발송 우편 번호",
    'admin.event.newUser.partnerDetails.table.head.marketPrice', // "구매 가격",
    // "admin.event.newUser.partnerDetails.table.head.tokenType", // "토큰 종류",
    'admin.event.newUser.partnerDetails.table.head.exchangeRate', // "적용 환율",
    'admin.event.newUser.partnerDetails.table.head.reward', // "보상 금액",
    'admin.event.newUser.partnerDetails.table.head.createdAt', // "로그 생성 시각"
  ];

  /**
   * 서버로부터 전달받은 request를 테이블에 표시할 내용으로 변환한다.
   *
   * 오브젝트 키는 param1, param10 등의 형식으로 param 다음에 숫자를 붙여서 사용한다.
   *
   * param1은 헤더의 첫번째 표시되는 항목이다.
   *
   * 헤더에는 표시되지 않지만 상세에 표시될 항목의 경우 headSize 이후의 숫자를 사용한다.
   *
   * key는 반드시 있어야 한다.
   * @param {object} row
   * @returns
   */
  const parse = (row) => {
    const index = row?.index;
    const accountNo = row?.accountNo;
    const marketListingNo = row?.marketListingNo;
    const postNo = mailNoToStr(row?.postNo);
    // const marketPrice =
    //   (convertBigNumToDecimalString(row?.marketPrice, 3) || 0) +
    //   getTokenTypeName(row?.tokenType);
    let marketPrice;  // 토큰 타입에따른 표기 방식 처리
    if (row?.tokenType === 5) {
      marketPrice = (row?.marketPrice / 10 ** 6).toFixed(3) + getTokenTypeName(row?.tokenType);
    } else {
      marketPrice = (convertBigNumToDecimalString(row?.marketPrice, 3) || 0) + getTokenTypeName(row?.tokenType);
    }
    const exchangeRate = row?.exchangeRate;
    const reward = (convertBigNumToDecimalString(row?.reward, 3) || 0) + 'PER';
    const createdAt = timeFormAPI.changeDataLog(row?.createdAt);

    return {
      key: index, // 키는 반드시 있어야 한다.
      param1: accountNo,
      param2: marketListingNo,
      param3: postNo,
      param4: marketPrice,
      param5: exchangeRate,
      param6: reward,
      param7: createdAt,
    };
  };

  /**
   * 로그 데이터를 클릭했을 때 보여줄 디테일 다이얼로그에 보여줄 항목을 작성한다.
   *
   * 입력값인 row는 위의 parse에서 변환된 값이다.
   *
   * @param {object} row
   * @returns
   */
  const details = (row) => {
    const array = [];
    if (row) {
      //
    }
    return array;
  };

  const [schema, setSchema] = useState();

  useEffect(() => {
    const headers = headerKeys.map((key) => t(key));
    const schema = create({
      heads: headers,
      parseFunc: parse,
      detailFunc: details,
    });
    setSchema(schema);
  }, [locale]);

  return { schema: schema };
}

export default useSchemaPartnerDetails;
